module.exports = __webpack_public_path__ + "static/media/fortehotel-512.cbf1b542.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fortehotel-512.png
// module id = 767
// module chunks = 0